import React from 'react';
import styles from './UIGameBottomPortrait.module.scss';
import { UIGameTradeCreator } from '../UIGameTradeCreator/UIGameTradeCreator.tsx';
import { UIGameActionButtonContainer } from '../UIGameActionButtonsContainer/index.ts';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGameActionBoxContainer } from '../UIGameActionBox/UIGameActionBoxContainer.tsx';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
import clsx from 'clsx';
import { UIGameHelpOpenChatLogsButton } from '../UIGameHelpButtons/UIGameHelpChatLogsButton/UIGameHelpChatLogsButton.tsx';
import { UIGameFeedsPortrait } from '../UIGameFeeds/UIGameFeedsPortrait.tsx';
import { UIGameReplayControlsContainer } from '../UIGameReplayControls/UIGameReplayControlsContainer.tsx';
import { UIGameDiceGroupContainer } from '../../common/UIGameDiceGroup/UIGameDiceGroupContainer.tsx';
import { StorageWrapper } from '../../utils/storage.ts';
export const UIGameBottomPortrait = ({ feedsPortraitVisibility, setFeedsPortraitVisibility, onClickLog })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const isShowTradePanel = useGameStore((state)=>state.gameTrade.isShowTradePanel);
    const actionBoxType = useGameStore((state)=>{
        var _state_actionBox_actionBoxData;
        return (_state_actionBox_actionBoxData = state.actionBox.actionBoxData) === null || _state_actionBox_actionBoxData === void 0 ? void 0 : _state_actionBox_actionBoxData.type;
    });
    const isActionBoxDiceVisible = useGameStore((state)=>{
        const data = state.actionBox.actionBoxData;
        if ((data === null || data === void 0 ? void 0 : data.type) != 'pickCard') return false;
        return data.props.showRolledDice == true;
    });
    const isReplay = useIsReplay();
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const isActionBoxOpening = actionBoxType != null;
    const isPopupShowing = isShowTradePanel || isActionBoxOpening;
    const rushGamesPlayed = StorageWrapper.getRushGamesPlayed();
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.bottomContainerPortrait, {
            [styles.popupShowing]: isPopupShowing || isReplay
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.actionsContainer
    }, /*#__PURE__*/ React.createElement(UIGameDiceGroupContainer, {
        playerColor: myColor,
        size: "large",
        className: clsx(styles.diceGroup, {
            [styles.hidden]: isPopupShowing || isReplay || isMyColorSpectator
        })
    }), /*#__PURE__*/ React.createElement(UIGameActionButtonContainer, {
        isPortraitLayout: true,
        className: clsx(styles.actionButtonContainer, {
            [styles.hidden]: isPopupShowing || isReplay || isMyColorSpectator
        })
    }), feedsPortraitVisibility !== 'none' && /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.gameChatLogsContainer, {
            [styles.rushIntroActive]: feedsPortraitVisibility === 'rush'
        })
    }, /*#__PURE__*/ React.createElement(UIGameFeedsPortrait, {
        visibility: feedsPortraitVisibility,
        onClickLog: onClickLog
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameHelpOpenChatLogsButtonContainer,
        "data-game-chat-logs-container": true
    }, /*#__PURE__*/ React.createElement(UIGameHelpOpenChatLogsButton, {
        rushGamesPlayed: rushGamesPlayed,
        feedsPortraitVisibility: feedsPortraitVisibility,
        setFeedsPortraitVisibility: setFeedsPortraitVisibility
    })), isActionBoxOpening && !isMyColorSpectator && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameActionBox
    }, !isReplay && isActionBoxDiceVisible && /*#__PURE__*/ React.createElement(UIGameDiceGroupContainer, {
        playerColor: myColor,
        size: "large",
        className: styles.actionBoxDiceGroup,
        disableDiceSound: true
    }), /*#__PURE__*/ React.createElement(UIGameActionBoxContainer, {
        isPortrait: true
    })), (isReplay || isMyColorSpectator) && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameReplayControlsContainer
    }, /*#__PURE__*/ React.createElement(UIGameReplayControlsContainer, {
        useMinimalControls: true,
        disableTooltips: true
    })), isMyColorSpectator ? /*#__PURE__*/ React.createElement("div", {
        className: styles.gameInventorySpectatorContainer
    }) : /*#__PURE__*/ React.createElement(UIGameTradeCreator, {
        isPortraitLayout: true,
        className: styles.gameInventoryContainer
    }));
};
